var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"om-button",class:{ 'om-button-ghost': _vm.ghost },attrs:{"type":"button","disabled":_vm.isPreparing},on:{"click":_vm.download}},[_c('i',{staticClass:"ni ni-cloud-download-95",attrs:{"aria-hidden":"true"}}),_vm._v("\n  "+_vm._s(_vm.isPreparing ? _vm.copy.preparingPdf : _vm.label || _vm.copy.downloadPdf)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }